var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDSparkCoreIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "access",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.88,
    cy: 31.76,
    r: 3.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.58,
    cy: 32,
    r: 11.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 27.18h27.46l4.34 3.86-5.3 5.3h-1.93L48.86 32h-1.62l-3.68 4.34-4.82-5.3-4.69 5.3h-7.46"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "amount-money",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9 36.41v5.83H11.18V21.67h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.73 42.24v5.92H5V27.59h6.18m28.76-4.33a2.73 2.73 0 0 0-2.15-1c-1.41 0-2 .86-2 1.7 0 2.39 4.24 1.33 4.24 4a2 2 0 0 1-2.15 1.91 3.23 3.23 0 0 1-2.54-1.28m2.45-6.37V20.3m0 11.7v-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54 36.41H16.27V15.84H59v20.57z"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "application",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.18 59H10.82V5h26.54l15.82 15.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.18 20.82H37.36V5M16.91 16.84H32m-15.09 7.64H32m-15.09 7.64H47.1m-30.19 7.65H47.1"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "auto-loans",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.56 42h5.94v-9.06a5 5 0 0 0-5-5H41.76l-4.5-9.41a4 4 0 0 0-3.59-2.26H7.82a3.32 3.32 0 0 0-3.32 3.35V42h5.19m11.41-.01h20.05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.85,
    cy: 41.99,
    r: 5.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 41.99,
    r: 5.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 27.97h37.88"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "baths",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.59 45.72H9.9l-4.16-18.7h53zM21.74 17a5.5 5.5 0 0 0-11 0v9.9m7.82 19l-4.04 7.43m35.44 0l-4.04-7.43",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "beds",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.3h43v16h-43zm43.3 41.49v5.54m-43.55-5.54v5.54m42.88-30.76L59 41.33v8.95H5v-8.95l5.5-15.76M59 41.44H4.75",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.62 48.07C41.61 52.45 37.3 56 32 56s-9.62-3.56-9.61-8m5.71-.27h23.56c1.44 0 3.64-.13 4.2-1.66.63-1.71-1-3.43-2.35-4.32A9.11 9.11 0 0 1 49.7 37a16.46 16.46 0 0 1-.49-4.14c-.07-2.24-.07-4.48-.06-6.73a26.68 26.68 0 0 0-.1-5.86A16.78 16.78 0 0 0 45.52 13c-5.15-6.12-15-7.85-22.16-3.9A16.37 16.37 0 0 0 15 20.23a27.31 27.31 0 0 0-.12 5.86c0 2.25 0 4.49-.07 6.73a16.47 16.47 0 0 1-.5 4.14 9.11 9.11 0 0 1-3.82 4.76c-1.33.89-3 2.6-2.36 4.31.56 1.53 2.75 1.7 4.2 1.68h23.55",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "blog",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "bevel",
    fill: "none",
    d: "M59 32c0 14.9-12.1 27-27 27S5 46.9 5 32 17.1 5 32 5c14.9-.1 26.9 11.9 27 26.8v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1 22.9c3.7 0 7.3 1.4 10 3.9 2.7 2.6 4 6.3 3.5 10m-13.5-23c6.1.1 12 2.5 16.4 6.7 4.3 4.3 6.5 10.3 6.1 16.4M20.3 23.1v22m12.3-7.3c0 3.7-3 6.7-6.5 6.7s-5.8-3-5.8-6.7 2.4-6.8 5.8-6.8 6.5 3 6.5 6.8z",
    strokeLinejoin: "bevel",
    fill: "none"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "calculator",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    height: 54,
    rx: 2.47,
    width: 37.63,
    x: 13.18,
    y: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 11.22h26.39v8.7H18.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.53,
    cy: 28.71,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28.71,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.25,
    cy: 28.71,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.53,
    cy: 38.96,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 38.96,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.25,
    cy: 38.96,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.53,
    cy: 49.03,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 49.03,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.25,
    cy: 49.03,
    r: 2.73
  })))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.1 7.1H57V57H7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 16.6H58M15.5 25.5h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3zm-30 10h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3zm-30 10h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3zm10 0h3v3h-3z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "call-team-member",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.97,
    cy: 21.92,
    rx: 11.49,
    ry: 11.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 21.92A16.9 16.9 0 1 1 34.7 38.8m7.48-3.25a26.28 26.28 0 0 1 16.37 24.27m-53.1 0A26.41 26.41 0 0 1 32 33.55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.85,
    cy: 40.4,
    r: 3.27
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "cash-back",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.12 32.21H5.27m9.8 10.07L5 32.21l10.07-10.07m43.72-2.96a12.47 12.47 0 0 0-9.72-4.71c-6.38 0-9.29 3.94-9.29 7.73C39.78 33 59 28.18 59 40.27c0 5.34-5 8.65-9.71 8.65s-8.51-2.19-11.52-5.8m11.3-28.65V7.74m0 48.52v-7.34",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chat-online",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.44 40.6v6.29h21.14l6.79 5.65v-5.65h4.65V24.95H45.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73 12.31H5.17v27.93h8.64v7.68l12.81-7.68h19.11z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 26.2,
    r: 3.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.63,
    cy: 26.2,
    r: 3.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 26.2,
    r: 3.05
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "check-mark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 32A27 27 0 1 1 32 5a26.89 26.89 0 0 1 27 27z",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.97 31.42l7.71 7.71 17.59-16.77",
    strokeMiterlimit: 10
  })))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M17.4 25.7L32 40.3l14.6-14.6"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-down-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41 25.7l14.57 14.6 14.61-14.57"
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-down-circle-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.41 25.7l14.57 14.6 14.61-14.57",
    stroke: "#fff"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-down-circle-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41 25.7l14.57 14.6 14.61-14.57"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M39.3 18.4L24.7 33l14.6 14.6"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-left-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3 46.59L22.7 32.02l14.57-14.61"
  })))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M24.7 47.6L39.3 33 24.7 18.4"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-right-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 46.59l14.6-14.57-14.57-14.61"
  })))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M46.6 40.3L32 25.7 17.4 40.3"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-up-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.59 38.3L32.02 23.7 17.41 38.27"
  })))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "chevron-up-circle-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.59 38.3L32.02 23.7 17.41 38.27"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.01 10.95L31 32.09l9.5 10.08"
  })))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.8 21.8l20.4 20.4m0-20.4L21.8 42.2"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "close-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 32A27 27 0 1 1 32 5a26.89 26.89 0 0 1 27 27zM21.77 21.77l20.46 20.46m0-20.46L21.77 42.23",
    fill: "none",
    strokeLinejoin: "bevel"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "cloud",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.52 29.92a13.43 13.43 0 0 0 .16-2A12.61 12.61 0 0 0 39.36 15a12.35 12.35 0 0 0-11.48 8.11 8.71 8.71 0 0 0-3.2-.6 9.31 9.31 0 0 0-9 7.29 9.08 9.08 0 0 0-1.49-.12 9.61 9.61 0 0 0 0 19.21h35.56A9.43 9.43 0 0 0 59 39.37a9.53 9.53 0 0 0-7.48-9.45zm-18.53 9.83l.02-11.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 35.99l5.1 5.12 5.11-5.1"
  })))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "communication",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.44 40.6v6.29h21.14l6.79 5.65v-5.65h4.65V24.95H45.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73 12.31H5.17v27.93h8.64v7.68l12.81-7.68h19.11z"
  })))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "condo",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.64 5.23h40.72v53.53H11.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.84 11.15h4.32v6.48h-4.32zm10.8 0h4.32v6.48h-4.32zm-21.6 0h4.32v6.48h-4.32zm10.8 10.79h4.32v6.48h-4.32zm10.8 0h4.32v6.48h-4.32zm-21.6 0h4.32v6.48h-4.32zm10.8 10.8h4.32v6.48h-4.32zm10.8 0h4.32v6.48h-4.32zm-21.6 0h4.32v6.48h-4.32z"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "cooling",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 4v56m5.88-53.96L32 11.92l-5.89-5.88m0 51.58L32 51.73l5.88 5.89M4 32h56M5.04 26.11L10.92 32l-5.88 5.88m53.58 0L52.73 32l5.89-5.89M12 52l40-40M10.03 45.68h8.32V54m35.92-36.44h-8.32V9.24M12 12l40 40M9.22 17.56h8.32V9.24m36.43 36.44h-8.32V54",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "credit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.45 28.63l-9.99 15.89",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45.87,
    fill: "#fff",
    r: 2.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 55.25A27 27 0 1 1 51 55",
    fill: "none"
  })))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "credit-card-payoff",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    height: 37.02,
    rx: 1,
    width: 54,
    x: 4.5,
    y: 13.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.69h54m-54 7.04h54M9.65 38.46h7.06v7.06H9.65z"
  })))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "dedicated-team",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.82,
    cy: 21.67,
    r: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 49.72v-9.86a11.82 11.82 0 0 0-23.63 0v9.86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.73,
    cy: 21.67,
    r: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53 31.09a11.81 11.81 0 0 0-19.72 8.77v9.86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.27,
    cy: 21.67,
    r: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.47 31.09a11.81 11.81 0 0 1 19.72 8.77v9.86"
  })))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "desktop-computer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11.09h54v32.38H5zm27 32.38v9.57m-17 0h34",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "document-review",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7 39.57H8.59V5h16.99L35.7 15.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 15.12H25.58V5m25.76 33.53a16.25 16.25 0 1 1-16.25-16.24 16.17 16.17 0 0 1 16.25 16.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37 51.24l7.1 7.26a1.73 1.73 0 0 0 2.37-2.5l-7-7.28z"
  })))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "documents",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.18 59H10.82V5h42.36v15.82zM25.12 16.11h15.09m-15.09 9.94h22.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.38 14.65l2.2 2.2 4.02-4.01m2.52 23.97h15.09m-23.83-1.47l2.2 2.21 4.02-4.02m-6.22-8.71l2.2 2.2 4.02-4.01"
  })))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.99 42.94l.02-21.88m-5.12 17.06l5.1 5.11 5.11-5.1"
  })))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "editable",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.53 29.58v28.18H5.5V15.32h31.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 12.29L34.13 40.16l-11.18 5.32 4.22-11.4L52.01 6.24z"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "educational-resources",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.84 5.5h32.41v44.04H17.84m2.94.39v8.57l3.92-2.37 4 2.37v-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.5h7.9v44.04h-7.9z"
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8 32l19.09 13.57m-53.75 0l19.17-13.63M5.25 18.02l26.88 19.11L59 18.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.87h54v28.25H5z"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "exclamation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".exclamation-circle{stroke-width:2px;fill:none}.exclamation-i-path{stroke-width:0}.exclamation-i-dot{stroke-width:1}"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "exclamation-circle",
    cx: 27,
    cy: 27,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "exclamation-i-path",
    d: "M26 12h2v23h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "exclamation-i-dot",
    fillRule: "nonzero",
    cx: 27,
    cy: 40.5,
    r: 1
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "exclamation-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".exclamation-filled-circle{stroke-width:0}.exclamation-filled-i-path{stroke-width:0;fill:#fff}.exclamation-filled-i-dot{stroke-width:1;stroke:#fff;fill:#fff}"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "exclamation-filled-circle",
    cx: 27,
    cy: 27,
    r: 27
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "exclamation-filled-i-dot",
    cx: 1,
    cy: 27.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "exclamation-filled-i-path",
    d: "M0 0h2v22H0z"
  }))))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 21.17v-4.33a2.28 2.28 0 0 1 2.38-2.58h6.06V5h-8.31c-9.29 0-11.37 6.86-11.37 11.31v4.86h-5.39V32h5.45v27h10.81V32h8l.37-4.26.65-6.57z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "facebook-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 21.17v-4.33a2.28 2.28 0 0 1 2.38-2.58h6.06V5h-8.31c-9.29 0-11.37 6.86-11.37 11.31v4.86h-5.39V32h5.45v27h10.81V32h8l.37-4.26.65-6.57z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "feedback",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.34 40.24l21.28 8.63L59.1 8.78 31.34 40.24 27.95 53.8l8.02-11.71m-13.63-5.1L4.51 29.75 59.1 8.78z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 36.84l5.55 16.97",
    strokeLinejoin: "bevel"
  })))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "find-agent",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.87 28.89A23.91 23.91 0 1 1 29 5a23.81 23.81 0 0 1 23.87 23.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.08 47.59l10.46 10.69A2.54 2.54 0 0 0 58 54.59L47.79 43.87z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.96,
    cy: 26.61,
    r: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 48.48a13.56 13.56 0 1 1 27.12 0"
  })))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "free",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33 21.74A10 10 0 0 0 32.55 18c-5.11 0-7.43 3.16-7.43 6.19 0 8.63 15.37 4.78 15.37 14.45 0 4.28-4 6.92-7.77 6.92a11.66 11.66 0 0 1-9.21-4.64m9.04-22.95v-5.38m0 38.82v-5.88M18.12 8.84L47.65 54"
  })))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "heat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 13.23h4.13M32 19.59h4.13M32 25.95h4.13m0 14.93a9.53 9.53 0 1 1-8.26 0V5h8.26zM32 32.32h4.13",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "home",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.58 57.32V35.89H25.42v21.43M4.51 25.43L32 6.68l27.49 18.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17 22.42v35.45H9.83V22.42"
  })))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "home-improvement",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15.16,
    rx: 1,
    width: 43.58,
    x: 6.29,
    y: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.12 13.17h7.59v15.88H28.08v11.38"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 18.31,
    rx: 1,
    width: 5.13,
    x: 25.52,
    y: 40.1
  })))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "home-shopping",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51 25.16L32 6.41l27.49 18.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17 22.15v35.44H9.83V22.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 25.05h2.52a3.34 3.34 0 0 1 3.3 2.31l4.25 15.42h17.48l5-13.2-25.67-.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.98,
    cy: 48.3,
    r: 2.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.45,
    cy: 48.3,
    r: 2.22
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "home-size",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 16.79H16.16l-.39 40.71H6.5v-51h51zm-38.37-.76V12.1m6.61 3.93V12.1m6.61 3.93V12.1m6.62 3.93V12.1m6.61 3.93V12.1m6.61 3.93V12.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67 33.22V57.5H23.5V33.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.08 35.65L38.79 22.8l18.71 13M15.91 52.31h-3.94m3.94-6.61h-3.94m3.94-6.61h-3.94m3.94-6.61h-3.94m3.94-6.61h-3.94m3.94-6.61h-3.94"
  })))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "information",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".information-circle{stroke-width:2px;fill:none}.information-i-path{stroke-width:0}.information-i-dot{stroke-width:1}"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "information-circle",
    cx: 27,
    cy: 27,
    r: 27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "information-i-dot",
    fillRule: "nonzero",
    cx: 27,
    cy: 18.2,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "information-i-path",
    d: "M26 23h2v14h-2z"
  })))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.21 32A13.79 13.79 0 1 1 32 45.79 13.8 13.8 0 0 1 18.21 32zm28-27H17.76A12.79 12.79 0 0 0 5 17.76v28.48A12.82 12.82 0 0 0 17.76 59h28.48A12.79 12.79 0 0 0 59 46.24V17.76A12.77 12.77 0 0 0 46.24 5zm2.45 7.6a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "instagram-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.21 32A13.79 13.79 0 1 1 32 45.79 13.8 13.8 0 0 1 18.21 32zm28-27H17.76A12.79 12.79 0 0 0 5 17.76v28.48A12.82 12.82 0 0 0 17.76 59h28.48A12.79 12.79 0 0 0 59 46.24V17.76A12.77 12.77 0 0 0 46.24 5zm2.45 7.6a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "land",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 57.06V34.28"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 21.59,
    rx: 18.91,
    ry: 10.85,
    transform: "rotate(-49.66 45.494 21.588)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5,
    cy: 21.59,
    rx: 10.85,
    ry: 18.91,
    transform: "rotate(-40.34 18.5 21.595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 34.28L48.2 17.8M32 34.28L15.8 17.8"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "landline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.19 43.19l-.27-.26C10.16 32.15 5.64 21.56 5.33 19.75c-.53-3.15.93-4.58.93-4.58l10.11-10c2.86 0 9.09 11.82 8.72 12.72s-3.3 3.6-4.43 4.67c-1.54 1.45-1.72 2.52-1.49 3.8.67 3.7 2.14 6.2 7 11.54l-.1-.1c5.34 4.9 7.83 6.38 11.52 7.05 1.28.23 2.35.06 3.8-1.49 1.06-1.13 3.77-4.06 4.66-4.44s12.66 5.87 12.7 8.74l-10 10.12s-1.42 1.47-4.57.93c-1.81-.3-12.38-4.84-23.14-15.62l-.26-.26z",
    fill: "none",
    strokeLinejoin: "bevel"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "laptop",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.82 37V15a1 1 0 0 1 1-1h38.36a1 1 0 0 1 1 1v22m5.4 12.99H6.42l5.08-11.98h41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.22 49.99l1.74-4.19h8.08l1.63 3.93"
  })))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "large-purchase",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43 27.17v-6.85a1 1 0 0 1 1-1h42a1 1 0 0 1 1 1v6.85"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7.45,
    rx: 1,
    width: 6,
    x: 4.57,
    y: 27.17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7.45,
    rx: 1,
    width: 6,
    x: 52.51,
    y: 27.17
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.59,
    cy: 27.02,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.43,
    cy: 27.02,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.44,
    cy: 27.02,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 4.39,
    rx: 1,
    strokeMiterlimit: 10,
    width: 47.72,
    x: 7.78,
    y: 34.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 39.12v5.56m37.16-5.56v5.56",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23h45v36h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 22.48v-3.41a15 15 0 0 0-29.93 0v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 37,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44v8.18"
  })))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "medical-expenses",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.18 5h7.48s1.72 24.8-13.82 24.8S12 5 12 5h7.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.32 48.8a10.21 10.21 0 0 1-20.41 0v-19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.32,
    cy: 43.4,
    r: 5.71
  })))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 32h48M8 18.68h48M8 45.32h48",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "mls",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.34 55.5H7v-47h37.42l-.06 40.66a6.35 6.35 0 0 0 6.32 6.34A6.34 6.34 0 0 0 57 49.16V27.25H43.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.53 16.11h25v9h-25zm-1.15 17.78h27.25M12.38 40.7h27.25m-27.25 6.97h27.25"
  })))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "mobile",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    height: 54,
    rx: 1,
    width: 29.44,
    x: 17.28,
    y: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 51.18h28.43m-20.4-39.84h13.38"
  })))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "mortgage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51 25.16L32 6.41l27.49 18.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17 22.15v35.44H9.83V22.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 27.85a6.94 6.94 0 0 0-5.42-2.63c-3.56 0-5.18 2.2-5.18 4.31 0 6 10.72 3.34 10.72 10.08 0 3-2.78 4.82-5.42 4.82a8.15 8.15 0 0 1-6.42-3.23m6.3-15.98v-3.75m0 27.06v-4.1"
  })))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "multi-family",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.23 57.34V35.89H15.07v21.45m33.86 0V35.89H35.77v21.45M4.5 25.42L32 6.67l27.5 18.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17 22.28v35.44H9.83V22.28"
  })))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "one-time-update",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.61 4.94l-5.58 4.58 4.57 5.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.24 10a22.75 22.75 0 0 0-17 22c0 17.26 20.15 28.44 34.8 19.29a22.73 22.73 0 0 0-12-42"
  })))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "organize",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.74 16.35v-4.09a2.46 2.46 0 0 1 .48-1.64 2.58 2.58 0 0 1 2-1h11.39s2.37-.27 2.46 2.52a.9.9 0 0 0 1 .73H59v34.78h-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 54.39V19a2.44 2.44 0 0 1 .47-1.64 2.58 2.58 0 0 1 2-1h11.4s2.37-.27 2.46 2.51c0 .45.51.73 1 .73h30v34.79z"
  })))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "our-family",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.62 35.04l-4.28-7.41M27.35 44.85h9.03M25.61 27.63l-4.43 7.67"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.97,
    cy: 16.63,
    rx: 3.98,
    ry: 4.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.57 26.77a7.55 7.55 0 0 1 14.8-.16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.97,
    cy: 18.74,
    r: 10.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 43.15,
    rx: 3.98,
    ry: 4.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 53.29a7.55 7.55 0 0 1 14.8-.15m3.27-10.3A10.94 10.94 0 1 1 16 34.33a10.92 10.92 0 0 1 10.66 8.51"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 42.89,
    rx: 3.98,
    ry: 4.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6 53.29a7.55 7.55 0 0 1 14.8-.15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 45,
    r: 10.93
  })))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "parking",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.69 49.19h5.06v-7.7a4.24 4.24 0 0 0-4.24-4.24h-10l-3.83-8a3.4 3.4 0 0 0-3.06-1.93h-22a2.83 2.83 0 0 0-2.83 2.83v19h4.42m9.68.04h17.08"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.83,
    cy: 49.19,
    r: 4.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.03,
    cy: 49.19,
    r: 4.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 37.25h32.27m18.23-13.02L31.77 9.95 4.25 24.16"
  })))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "payment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33 21.74A10 10 0 0 0 32.55 18c-5.11 0-7.43 3.16-7.43 6.19 0 8.63 15.37 4.78 15.37 14.45 0 4.28-4 6.92-7.77 6.92a11.66 11.66 0 0 1-9.21-4.64m9.04-22.95v-5.38m0 38.82v-5.88"
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "payment-center",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.91 28.37a3.47 3.47 0 0 0-2.72-1.31c-1.78 0-2.59 1.09-2.59 2.15 0 3 5.36 1.68 5.36 5.06a2.59 2.59 0 0 1-2.71 2.42A4.11 4.11 0 0 1 29 35.07m3.19-8.01v-2.42m0 14.72v-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18.99h54v26H5z"
  })))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "pinterest",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.17 56.73A26.57 26.57 0 1 1 24.66 58z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 58.08c.8-3 2-7.42 2.37-8.92L29 42.74c.88 1.68 3.46 3.1 6.19 3.1 8.15 0 14-7.49 14-16.8 0-8.92-7.28-15.59-16.64-15.59-11.65 0-17.84 7.82-17.84 16.34 0 4 2.11 8.89 5.48 10.46.51.24.78.13.9-.36s.55-2.21.75-3.06a.81.81 0 0 0-.19-.78 10.53 10.53 0 0 1-2-6.16c0-6 4.51-11.72 12.2-11.72 6.63 0 11.27 4.52 11.27 11 0 7.3-3.68 12.36-8.48 12.36a3.92 3.92 0 0 1-4-4.88c.76-3.21 2.23-6.67 2.23-9 0-2.07-1.11-3.8-3.41-3.8-2.71 0-4.89 2.8-4.89 6.56a9.66 9.66 0 0 0 .81 4s-2.68 11.32-3.17 13.43c-.34 1.48-1.15 5.72-1.78 8.57C20.11 58 25 58.08 25 58.08z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "play",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 32A27 27 0 1 1 32 5a26.89 26.89 0 0 1 27 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 19.83v24.34l21.6-13.1z"
  })))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 17.67v28.66M17.67 32h28.66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  })))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "prequalified",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.82 59h42.36V5H26.64L10.82 20.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.82 20.82h15.82V5m-6.96 29.68l7.71 7.71 17.59-16.78"
  })))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "price-per-sq-ft",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.07 59H14.93V15.9L25.49 5h13.58l10 10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33 21.74A10 10 0 0 0 32.55 18c-5.11 0-7.43 3.16-7.43 6.19 0 8.63 15.37 4.78 15.37 14.45 0 4.28-4 6.92-7.77 6.92a11.66 11.66 0 0 1-9.21-4.64m9.04-22.95v-5.38m0 38.82v-5.88"
  })))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "print",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21.57V7.32h31.6v14.25M16 46.95H5V21.57h54v25.38H48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8 37.04v19.52H16.2V37.04m-5.57.56h42.74"
  })))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: 10,
    cx: 32,
    cy: 31.9,
    r: 27
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.8 25.5s1-5.1 6.2-5.1c4.8 0 6 3.3 5.9 5.1 0 1.8-.6 3-3.2 5.2s-3.2 2.8-3.1 5.9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.9,
    cy: 42.6,
    r: 0.6
  })))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "rate-shield",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 57.94s10.75-6.87 15.64-9.81c4.36-2.64 5.86-8.67 5.86-13.44V6.52C38.84 17.31 32 5.94 32 5.94s-6.84 11.37-21.5.58v28.17c0 4.77 1.49 10.8 5.86 13.44C21.25 51.07 32 57.94 32 57.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35 31.62l7.71 7.7 17.59-16.77"
  })))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "rates",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4v55h55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 58.73L20.16 40.1l6.26 6.26 9.69-13.37L42 37.94l12.61-13.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81 33.83v-9.4h-9.4"
  })))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "recurring-update",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.61 4.94l-5.58 4.58 4.57 5.58m-9.37 44.21l5.58-4.58-4.58-5.58M32 9.28a22.72 22.72 0 0 1 6.44 44.5m-6.44.94a22.72 22.72 0 0 1-5.84-44.67",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "refinance",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.64 4.5l-4.58 4.54 4.98 5.01M28.27 59.5l4.57-4.54-4.97-5.01",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.23 54.54a23.12 23.12 0 0 0-5.14-45.63m-5.22.57a23.12 23.12 0 0 0 5 45.66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.93,
    cy: 25.83,
    r: 3.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.25,
    cy: 38.15,
    r: 3.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85 22.23L22.33 41.75"
  }))))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "reviews",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.68 14.88l3.87 7.84 8.64 1.26-6.25 6.1 1.47 8.61-7.73-4.07-7.73 4.07 1.47-8.61-6.25-6.1 8.64-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.81V45.2h11.77v10.99L32.88 45.2H59V7.81z"
  })))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "rocket",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9c-18.2 0-34.8 10.3-42.9 26.5L2.6 253.3c-8 16 3.6 34.7 21.5 34.7h95.1c-5.9 12.8-11.9 25.5-18 37.7-3.1 6.2-1.9 13.6 3 18.5l63.6 63.6c4.9 4.9 12.3 6.1 18.5 3 12.2-6.1 24.9-12 37.7-17.9V488c0 17.8 18.8 29.4 34.7 21.5l98.7-49.4c16.3-8.1 26.5-24.8 26.5-42.9V312.8c72.6-46.3 128-108.4 128-211.1.1-25.2.1-50.4-6.8-82.6zM400 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "same-day",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18.77v17.52l10.22 10.22M21.3 5l5.86 3.9-4.27 6.42",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.61 8.91a25.24 25.24 0 1 0 8.9 0",
    strokeLinejoin: "bevel"
  })))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "savings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 27.82h-4.62a19.75 19.75 0 0 0-9.47-11.19L46.82 7s-7.73 1.09-10.6 6.88c-.18 0-1.27-.24-2.54-.43a27.89 27.89 0 0 0-3.63-.36c-8.7 0-16.31 3.7-20.52 9.25a16.39 16.39 0 0 0-3.48 10c0 5.64 3 10.72 7.86 14.24l-2.6 6.77L20.62 57 23 50.71a29.22 29.22 0 0 0 7 .84 29.71 29.71 0 0 0 5.4-.49L37.73 57 47 53.33l-2.2-5.84a19.83 19.83 0 0 0 8.2-9.56h5zM11.06 19.8A6.53 6.53 0 0 1 13 7.9m9.69 15.77h12.85",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "schools",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24.76L32 13.35l25.5 11.41L32 38.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.06 28.85v10.3L32.23 49.42 13.94 39.15v-10.3M8 25.55v25.1"
  })))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9 28.9c0 5.4-1.8 10.3-4.7 14.3-4.4 5.8-11.3 9.6-19.2 9.6-13.2 0-23.9-10.7-23.9-23.9S15.8 5 29 5s23.9 10.7 23.9 23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1 47.6l10.5 10.7c2.5 2.3 5.9-1.4 3.5-3.7L47.8 43.9l-3.7 3.7z"
  })))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "secure-process",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.86 12.41C25.84 12.05 32 5.5 32 5.5s6.92 6.55 19.12 6.91c.28 0 .57 0 1 .08v3.27c0 7.13-.07 14.27 0 21.4a14.74 14.74 0 0 1-3.67 10c-4.25 5.08-9.78 8.4-15.69 11.14a2.22 2.22 0 0 1-1.68 0c-5.8-2.7-11.21-6-15.44-10.88a15.12 15.12 0 0 1-3.88-10.51c.24-8.06.1-16.15.1-24.5zM32 58.5v-53",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 37.5v-11h-6.85a20.87 20.87 0 0 0-2-4.88L55 16.8 47.2 9l-4.78 4.8a21.62 21.62 0 0 0-4.92-2.07V5h-11v6.69a21.14 21.14 0 0 0-5 2.05L16.8 9 9 16.8l4.72 4.72a21.14 21.14 0 0 0-2.05 5H5v11h6.73a21.62 21.62 0 0 0 2.07 4.92L9 47.2l7.8 7.8 4.82-4.83a20.87 20.87 0 0 0 4.88 2V59h11v-6.9a20.89 20.89 0 0 0 4.82-2L47.2 55l7.8-7.8-4.89-4.88a20.89 20.89 0 0 0 2-4.82z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 13.5
  })))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "single",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 20.48,
    rx: 12.29,
    ry: 12.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72 56a23.28 23.28 0 0 1 46.56 0"
  })))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "small-business",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 21.86a8.23 8.23 0 0 1-5.3-1.95 8.18 8.18 0 0 1-10.6 0 8.18 8.18 0 0 1-10.6 0 8.18 8.18 0 0 1-10.6 0 8.18 8.18 0 0 1-10.6 0 8.23 8.23 0 0 1-5.3 1.95l9-16.25h35zM39.34 58.39V34.47H24.66v23.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35 21.86v36.53H8.65V21.86"
  })))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "snapchat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.34 57.34h-.68c-3.2 0-5.25-1.45-7.24-2.85a10.46 10.46 0 0 0-4.19-2.14 13.81 13.81 0 0 0-2.2-.19 14.72 14.72 0 0 0-3.05.35 6.44 6.44 0 0 1-1.13.16.71.71 0 0 1-.79-.56c-.13-.43-.22-.85-.31-1.25-.22-1-.39-1.68-.82-1.75-5.07-.78-6.53-1.85-6.85-2.61a.94.94 0 0 1-.08-.32.58.58 0 0 1 .48-.6c7.8-1.28 11.3-9.25 11.44-9.59a3 3 0 0 0 .28-2.5c-.53-1.26-2.28-1.81-3.43-2.18-.29-.09-.55-.17-.77-.26-2.3-.91-2.49-1.84-2.4-2.32a2.18 2.18 0 0 1 2.12-1.38 1.39 1.39 0 0 1 .63.13 6.77 6.77 0 0 0 2.78.73 2.31 2.31 0 0 0 1.66-.53c0-.53-.07-1.08-.1-1.65-.24-3.69-.52-8.27.64-10.88a14.11 14.11 0 0 1 13.1-8.45h1.09a14.14 14.14 0 0 1 13.13 8.45c1.16 2.62.88 7.2.64 10.89v.16c0 .51-.06 1-.09 1.49a2.24 2.24 0 0 0 1.52.53 7 7 0 0 0 2.62-.73 1.85 1.85 0 0 1 .81-.16 2.42 2.42 0 0 1 .94.18 1.72 1.72 0 0 1 1.31 1.4c0 .54-.4 1.36-2.42 2.15-.21.09-.48.17-.77.26-1.15.37-2.9.92-3.43 2.18a2.94 2.94 0 0 0 .28 2.5c.14.34 3.64 8.31 11.44 9.59a.58.58 0 0 1 .48.6.89.89 0 0 1-.08.32c-.32.76-1.77 1.82-6.85 2.61-.41.06-.57.6-.82 1.74-.09.41-.18.81-.31 1.24a.68.68 0 0 1-.72.54h-.07a6.68 6.68 0 0 1-1.13-.15 15 15 0 0 0-3-.33 13.81 13.81 0 0 0-2.2.19 10.56 10.56 0 0 0-4.19 2.13c-2.02 1.41-4.07 2.86-7.27 2.86z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "technology",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.12 12.88a27 27 0 1 1-38.19 0 26.78 26.78 0 0 1 38.19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 28.53a3.75 3.75 0 0 1 1.07 2.13 3.77 3.77 0 1 1-1.07-2.13zm9.09 6.36a3.79 3.79 0 0 1 0 5.35 3.78 3.78 0 1 1 0-5.35zm11.81-1.82a3.79 3.79 0 1 1-5.35 0 3.81 3.81 0 0 1 5.35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35 39.38v7.27L9.6 47.1m19.94-13.17v-7.27l28.86-.46m-37.49.91v-7.27l35.01-.45"
  })))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "thumbs-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4 40.8c4.29-1 6.8-2.11 7-6.45.36-7 2.7-18.56 3.26-22.63.39-2.8-1.53-6.58-4.52-6.58a137.1 137.1 0 0 0-8.8 19.26c-.79 2-1.53 2.76-4.13 2.83s-5 .32-7.62.32v24.82c2.66 0 5.12-.21 7.67-.31a2.89 2.89 0 0 1 3.38 2.7 4.77 4.77 0 0 0 4.72 4c5.38.21 12.94.07 18.6.07m-3.12-33.94h-8.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84 24.89c-2.37 0-3.73 1.54-3.8 4.13s1.33 4.11 3.45 4.18c5.47.16 10.95.19 16.42 0 2.22-.08 3.65-1.74 3.47-4.48-.17-2.5-1.56-3.78-3.72-3.83-2.59-.06-13.13-.03-15.82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.54 41.81c2.18-.06 3.56-1.43 3.68-3.91.13-2.66-1.25-4.36-3.52-4.44-4.75-.17-9.52-.17-14.27 0-2.12.09-3.45 1.77-3.39 4.24s1.36 4 3.54 4.08 4.55 0 6.83 0 4.76.11 7.13.03zm-13.7.08c-2.37 0-3.73 1.54-3.8 4.14s1.33 4.11 3.45 4.18c5.47.16 8.79.19 14.26 0 2.21-.08 3.65-1.74 3.46-4.48-.21-2.5-1.56-3.73-3.72-3.83-2.58-.06-3 0-5.59 0s-5.37-.03-8.06-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79 58.82c2.18-.07 3.55-1.44 3.67-3.91.13-2.67-1.25-4.37-3.52-4.45-4.75-.17-6.76-.16-11.51 0-2.12.08-3.45 1.76-3.39 4.24s1.36 4 3.54 4.07 4.55 0 6.83 0 2 .12 4.38.05z"
  })))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "townhouse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.65 18.46V59h-39.3V18.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72 22.61h7.37v7.37h-7.37zm17.19 0h7.37v7.37h-7.37zM19.72 37.35h7.37v7.37h-7.37zm17.19 0h7.37v7.37h-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91 23.79L31.92 5l27.17 18.32"
  })))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.23 57.04H17.77l-5.34-44.26h39.14zm-20.9-44.26L25.37 6h13.26l.04 6.78m-6.67 0v44.26m-9.79-43.3L23.99 58m16.02 0l1.78-44.26m-36.03-.96h52.48",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 15.22A24 24 0 0 1 53 17a11.16 11.16 0 0 0 5-6.17 23.09 23.09 0 0 1-7.19 2.71 11.33 11.33 0 0 0-19.53 7.56 11.44 11.44 0 0 0 .33 2.53A32 32 0 0 1 8.35 12a11 11 0 0 0 3.46 14.83 10.88 10.88 0 0 1-5.1-1.38v.15a10.63 10.63 0 0 0 .77 4 11.26 11.26 0 0 0 8.29 6.86 11 11 0 0 1-3 .42 10.06 10.06 0 0 1-2.12-.24 11.39 11.39 0 0 0 10.55 7.78 22.78 22.78 0 0 1-14 4.75c-.92 0-1.79-.07-2.71-.15a32.6 32.6 0 0 0 17.3 5c17.63 0 28.51-12.2 31.35-24.88a31 31 0 0 0 .74-6.71V21a23.25 23.25 0 0 0 5.61-5.76z",
    fill: "none",
    strokeLinejoin: "bevel"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "twitter-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 15.22A24 24 0 0 1 53 17a11.16 11.16 0 0 0 5-6.17 23.09 23.09 0 0 1-7.19 2.71 11.33 11.33 0 0 0-19.53 7.56 11.44 11.44 0 0 0 .33 2.53A32 32 0 0 1 8.35 12a11 11 0 0 0 3.46 14.83 10.88 10.88 0 0 1-5.1-1.38v.15a10.63 10.63 0 0 0 .77 4 11.26 11.26 0 0 0 8.29 6.86 11 11 0 0 1-3 .42 10.06 10.06 0 0 1-2.12-.24 11.39 11.39 0 0 0 10.55 7.78 22.78 22.78 0 0 1-14 4.75c-.92 0-1.79-.07-2.71-.15a32.6 32.6 0 0 0 17.3 5c17.63 0 28.51-12.2 31.35-24.88a31 31 0 0 0 .74-6.71V21a23.25 23.25 0 0 0 5.61-5.76z",
    fill: "none",
    strokeLinejoin: "bevel"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "unlock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23h45v36h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 11.06A14.59 14.59 0 0 0 32 5a15 15 0 0 0-15 14.07v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 37,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44v8.18"
  })))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "update",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    fill: "none",
    d: "M37.61 4.94l-5.58 4.58 4.57 5.58m-9.37 44.21l5.58-4.58-4.58-5.58M32 9.28a22.72 22.72 0 0 1 6.44 44.5m-6.44.94a22.72 22.72 0 0 1-5.84-44.67"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.01 21.06l-.02 21.88m.02-21.88l-.02 21.88m5.11-17.06l-5.09-5.11-5.12 5.1"
  })))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3 32c0 6.1-2 11.8-5.4 16.3-5 6.7-12.9 11-21.9 11C16.9 59.3 4.7 47.1 4.7 32S16.9 4.7 32 4.7 59.3 16.9 59.3 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4 28.3c0 4.8-3.9 8.7-8.7 8.7S22 33.1 22 28.3s3.9-8.7 8.7-8.7c4.9 0 8.7 3.9 8.7 8.7zm-24.7 25c.5-9.1 8-16.3 17.3-16.3s16.8 7.2 17.3 16.4"
  })))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "verified-approval",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.87 21.82V57.5H9.53V21.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 25.38L32 6.5l27.5 19.11m-40.15 9.07l7.71 7.71 17.59-16.78"
  })))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "vip",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.04 24.47L58 27.15 44.97 39.92 47.99 58l-16.04-8.58-16.1 8.5 3.12-18.07L6 27.02l17.97-2.59L32.05 8z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "wifi",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 48.62,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.94a16.42 16.42 0 0 1 24.1-.11M15 33.5a22.25 22.25 0 0 1 34 0m-38.91-7.39a27.73 27.73 0 0 1 43.82 0",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "written-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.85 29.28h9.77m-9.77 6.47h12.71m-12.71 7.71H52.5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 31.3v18.91h-50V21.73h33.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9 18.02L41.84 37.54l-7.82 3.72 2.95-7.98 17.39-19.49z"
  })))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "year-built",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.51 38.82L5.5 24.41h43.98L30.62 45.74h-7.49"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.21,
    cy: 45.28,
    r: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.22 26.67v23.06c0 2.2-1 2.53-2.31.74L37 39.29m21.5-25.02L39.64 35.59"
  })))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.87 19a6.76 6.76 0 0 0-4.77-4.77C48.89 13.1 32 13.1 32 13.1s-16.89 0-21.1 1.13A6.76 6.76 0 0 0 6.13 19C5 23.21 5 32 5 32s0 8.79 1.13 13a6.76 6.76 0 0 0 4.77 4.77C15.11 50.9 32 50.9 32 50.9s16.89 0 21.1-1.13A6.76 6.76 0 0 0 57.87 45C59 40.79 59 32 59 32s0-8.79-1.13-13zM26.6 40.1V23.9l14 8.1z",
    fill: "none",
    strokeMiterlimit: 10
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 64 64",
    id: "youtube-two-color",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.87 19a6.76 6.76 0 0 0-4.77-4.77C48.89 13.1 32 13.1 32 13.1s-16.89 0-21.1 1.13A6.76 6.76 0 0 0 6.13 19C5 23.21 5 32 5 32s0 8.79 1.13 13a6.76 6.76 0 0 0 4.77 4.77C15.11 50.9 32 50.9 32 50.9s16.89 0 21.1-1.13A6.76 6.76 0 0 0 57.87 45C59 40.79 59 32 59 32s0-8.79-1.13-13zM26.6 40.1V23.9l14 8.1z",
    fill: "none",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDSparkCoreIcons);
export default __webpack_public_path__ + "static/media/D-SparkCoreIcons.e259a63e0d3b6d0f63f59a38a9e73cda.svg";
export { ForwardRef as ReactComponent };